import { render } from "./gsrst0105010203.vue?vue&type=template&id=510e68c8&scoped=true"
import script from "./gsrst0105010203.vue?vue&type=script&lang=js"
export * from "./gsrst0105010203.vue?vue&type=script&lang=js"

import "./gsrst0105010203.vue?vue&type=style&index=0&id=510e68c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-510e68c8"]])

export default __exports__